import * as React from 'react';

import { Grid } from "@material-ui/core";
import { MarketCategoryThirtyDaysVolume } from './volume/MarketCategoryThirtyDaysVolume';
import { MarketCategoryThirtyDaysVolumeEvolution } from './volume-evolution/MarketCategoryThirtyDaysVolumeEvolution';
import { MarketCategoryThirtyDaysBillingEvolution } from './billing-evolution/MarketCategoryThirtyDaysBillingEvolution';
import { MarketCategoryThirtyDaysProductEvolution } from './product-evolution/MarketCategoryThirtyDaysProductEvolution';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_MARKET } from 'src/component/shared';

import './MarketCategoriesThirtyDays.scss';

const MARKET_CATEGORIES_EVOLUTION = gql`
query marketCategoryThirtyDaysEvolution($customFilter:  MarketShareCustomFilter) {
    marketCategoryThirtyDaysEvolution(marketShareCustomFilter: $customFilter) {
        category,
        billing_evolution,
        volume_evolution,
        sku_evolution
    }
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoriesThirtyDaysProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoriesThirtyDaysState {
    categoriesVolumeArray: string[]
}

export class MarketCategoriesThirtyDays extends React.Component<IMarketCategoriesThirtyDaysProps, IMarketCategoriesThirtyDaysState> {
    constructor(props: IMarketCategoriesThirtyDaysProps) {
        super(props);

        this.state = {
            categoriesVolumeArray:[],
        }

        this.fillCategoryVolumeArray = this.fillCategoryVolumeArray.bind(this);
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
              "isChart": true,
            }
        };
        const categoriesVolumeArray = [...this.state.categoriesVolumeArray];
        return (
            <Grid container={true} spacing={16} className="MarketCategoriesThirtyDays" >
                <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}  >
                    {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                        return (
                            <Query query={MARKET_CATEGORIES_EVOLUTION} variables={QueryFilter.getFilterMarket(clientC, jsonFilter, ['category'], false)}>
                                {({ loading, error, data, client}) => {
                                    return (
                                        <Grid container={true} spacing={16} className="MarketCategoriesThirtyDays" >
                                            <Grid item={true} xs={6} sm={6}>
                                                <MarketCategoryThirtyDaysVolume fillCategoryVolumeArray={this.fillCategoryVolumeArray} />
                                            </Grid>
                                            {categoriesVolumeArray && categoriesVolumeArray.length >0 && <Grid item={true} xs={6} sm={6}>
                                                <MarketCategoryThirtyDaysVolumeEvolution 
                                                    categoriesVolumeArrayProp={categoriesVolumeArray} 
                                                    data={data}
                                                    loading={loading} 
                                                />
                                            </Grid>}
                                        
                                            {categoriesVolumeArray && categoriesVolumeArray.length >0 && <Grid item={true} xs={6} sm={6}>
                                                <MarketCategoryThirtyDaysBillingEvolution 
                                                    categoriesVolumeArrayProp={categoriesVolumeArray}
                                                    data={data}
                                                    loading={loading} 
                                                />
                                            </Grid>}
                                        
                                            {categoriesVolumeArray && categoriesVolumeArray.length >0 && <Grid item={true} xs={6} sm={6}>
                                                <MarketCategoryThirtyDaysProductEvolution 
                                                    categoriesVolumeArrayProp={categoriesVolumeArray} 
                                                    data={data}
                                                    loading={loading} 
                                                />
                                            </Grid>}
                                        </Grid>
                                    );
                                }}
                            </Query>
                        );

                    }}
                </Query>
            </Grid>
        );
    }

    private fillCategoryVolumeArray = (newCategoriesVolumeArray: string[]) => {
        const atualCategories:string[] = [... this.state.categoriesVolumeArray];
        if(atualCategories.length === newCategoriesVolumeArray.length) {
            const distincts:string[] = atualCategories.filter((atual:string) => !newCategoriesVolumeArray.includes(atual));
            if(!distincts || distincts.length === 0) {
                return;
            }
        }

        this.setState({categoriesVolumeArray: newCategoriesVolumeArray});
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/categories/thirty-days/MarketCategoriesThirtyDays.tsx